import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';
import { segunTienda } from '../utils/tienda';

// Membresías de Kontrol. La suscripción SOLO se lee desde la app: la escribe el
// sistema (prueba al crear el negocio) o la admin vía RPC (sql/079). El modo
// solo-lectura de una cuenta pausada lo hace cumplir la BD, no esta pantalla.

// WhatsApp de ventas de Kontrol (a dónde escriben para activar un plan).
export const WHATSAPP_VENTAS = '50492080375';

// Precio fundador: los primeros 25 negocios que pagan se quedan con él para
// siempre (lo marca la BD, sql/085).
// Precios por mes. Honduras paga en lempiras; los demás países en dólares.
// "anual" = precio por mes pagando el año por adelantado (−20%).
// Precios del lanzamiento (decisión de Merly, 28-oct-2026, sql/143): normales
// L 299 / 599 / 1,099 y fundador L 249 / 499 / 899 (25 cupos). Se quitó la
// subida del 1-ene-2027: precios2027 = preciosLanzamiento y no hay aviso.
// Debe coincidir con api/_lib/pagos.js (PRECIOS) y precio_kontrol() (sql/143).
export const FECHA_CAMBIO_PRECIOS = '2027-01-01T06:00:00Z'; // 00:00 en Honduras (UTC−6)
export const preciosNuevosVigentes = (ahora = new Date()) => ahora >= new Date(FECHA_CAMBIO_PRECIOS);
const vigentes = (plan) => (preciosNuevosVigentes() ? plan.precios2027 : plan.preciosLanzamiento);

export const PLANES = [
  {
    clave: 'emprende', nombre: 'Emprende', icono: '🌱',
    preciosLanzamiento: { HNL: { mensual: 299, anual: 239 }, USD: { mensual: 11.99, anual: 9.59 } },
    precios2027: { HNL: { mensual: 299, anual: 239 }, USD: { mensual: 11.99, anual: 9.59 } },
    get precios() { return vigentes(this); },
    fundador: { HNL: { mensual: 249, anual: 199 }, USD: { mensual: 9.99, anual: 7.99 } },
    puntos: ['1 usuario', '30 publicaciones con IA al mes (3 premium)', '15 fotos con IA al mes', 'Productos y servicios ilimitados', 'Reportes básicos', 'Herramientas y Ayuda: videos de cada módulo'],
  },
  {
    clave: 'crece', nombre: 'Crece', icono: '⭐', recomendado: true,
    preciosLanzamiento: { HNL: { mensual: 599, anual: 479 }, USD: { mensual: 22.99, anual: 18.39 } },
    precios2027: { HNL: { mensual: 599, anual: 479 }, USD: { mensual: 22.99, anual: 18.39 } },
    get precios() { return vigentes(this); },
    fundador: { HNL: { mensual: 499, anual: 399 }, USD: { mensual: 19.99, anual: 15.99 } },
    puntos: ['3 usuarios', '80 publicaciones con IA al mes (10 premium)', '60 fotos con IA al mes', 'Productos y servicios ilimitados', 'Reportes avanzados', 'Acceso anticipado a funciones nuevas', 'Herramientas y Ayuda: videos de cada módulo'],
  },
  {
    clave: 'negocio', nombre: 'Pro', icono: '🚀',
    preciosLanzamiento: { HNL: { mensual: 1099, anual: 879 }, USD: { mensual: 41.99, anual: 33.59 } },
    precios2027: { HNL: { mensual: 1099, anual: 879 }, USD: { mensual: 41.99, anual: 33.59 } },
    get precios() { return vigentes(this); },
    fundador: { HNL: { mensual: 899, anual: 719 }, USD: { mensual: 34.99, anual: 27.99 } },
    puntos: ['Hasta 10 usuarios', '200 publicaciones con IA al mes (25 premium)', '200 fotos con IA al mes', 'Productos y servicios ilimitados', 'Reportes avanzados + exportar', 'Acceso anticipado a funciones nuevas', 'Herramientas y Ayuda: videos de cada módulo'],
  },
];

// Moneda en que se le cobra a un negocio: lempiras en Honduras, dólares en el resto.
export const monedaCobro = (monedaNegocio) => (monedaNegocio === 'HNL' ? 'HNL' : 'USD');

const fmtMonto = (monto, moneda) => (moneda === 'HNL'
  ? `L ${Math.round(monto).toLocaleString('es-HN')}`
  : `$${monto.toFixed(2)}`);

// Referencia para mostrar el equivalente en dólares de los precios en lempiras.
export const TASA_LEMPIRA = 26.8;

// { porMes, alAnio, usdMes, usdAnio } ya formateados, ej. "L 499", "L 4,788",
// "US$18.62" (los usd solo para lempiras; null si ya es en dólares).
export function precioPlan(plan, ciclo, moneda, fundador = false) {
  const m = monedaCobro(moneda);
  const porMes = (fundador ? plan.fundador : plan.precios)[m][ciclo];
  const usd = (x) => (m === 'HNL' ? `US$${(x / TASA_LEMPIRA).toFixed(2)}` : null);
  return { porMes: fmtMonto(porMes, m), alAnio: fmtMonto(porMes * 12, m), usdMes: usd(porMes), usdAnio: usd(porMes * 12), moneda: m };
}

// Aviso "precio de lanzamiento" (solo antes del cambio). null después del 1-ene-2027.
export function avisoLanzamiento(moneda, ciclo = 'mensual', ahora = new Date()) {
  if (preciosNuevosVigentes(ahora)) return null;
  // Sin subida programada (sql/143): no hay aviso.
  if (PLANES.every((p) => JSON.stringify(p.precios2027) === JSON.stringify(p.preciosLanzamiento))) return null;
  const m = monedaCobro(moneda);
  const nuevos = PLANES.map((p) => fmtMonto(p.precios2027[m][ciclo], m)).join(' / ');
  return `Precio de lanzamiento hasta el 31 de diciembre. Desde el 1 de enero de 2027: ${nuevos} al mes. Quien entra con precio fundador lo conserva para siempre.`;
}

// Plan Empresa: a la medida, sin precio fijo (se cotiza por WhatsApp). Todavía
// no existe en la BD; se activa a mano como Pro mientras tanto.
export const PLAN_EMPRESA = {
  nombre: 'Empresa', icono: '🏢',
  puntos: ['Más de 10 usuarios', 'Varias sucursales', 'Herramientas y reportes a la medida', 'Acompañamiento personalizado'],
};

export function linkCotizarEmpresa(negocioNombre) {
  const texto = `¡Hola Kontrol! 👋 Me interesa el plan Empresa. Quisiera una cotización.\nMi negocio: ${negocioNombre || ''}`;
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_VENTAS}&text=${encodeURIComponent(texto)}`;
}


export const planPorClave = (clave) => PLANES.find((p) => p.clave === clave) || null;

// Cupos de precio fundador que quedan (de 25).
export async function cuposFundador() {
  const { data, error } = await supabase.rpc('cupos_fundador');
  return error ? 0 : (data || 0);
}

export async function obtenerSuscripcion() {
  const { data, error } = await supabase
    .from('suscripciones').select('*').eq('negocio_id', getNegocioId()).maybeSingle();
  if (error) throw error;
  return data;
}

// Funciones que dependen del plan (plan mínimo que las incluye). La prueba y
// la cortesía usan el plan de la suscripción (por defecto Pro). Sin datos
// de suscripción no se bloquea nada.
const NIVEL_PLAN = { emprende: 1, crece: 2, negocio: 3 };
export const FUNCION_PLAN = {
  reportes_avanzados: 'crece',
  exportar: 'negocio',
};
export function tieneFuncion(suscripcion, funcion) {
  if (!suscripcion) return true;
  return (NIVEL_PLAN[suscripcion.plan] || 3) >= NIVEL_PLAN[FUNCION_PLAN[funcion]];
}

// Resumen para la interfaz: { vigente, estado, diasRestantes, hasta }.
// Debe coincidir con suscripcion_vigente() de la BD (3 días de gracia al pago).
export function resumenSuscripcion(s) {
  if (!s) return { vigente: true, estado: 'sin_datos', diasRestantes: null, hasta: null };
  const ahora = Date.now();
  const dias = (fecha) => Math.max(0, Math.ceil((new Date(fecha).getTime() - ahora) / 86400000));
  if (s.estado === 'cortesia') return { vigente: true, estado: 'cortesia', diasRestantes: null, hasta: null };
  if (s.estado === 'prueba') {
    const vigente = new Date(s.prueba_hasta).getTime() > ahora;
    return { vigente, estado: vigente ? 'prueba' : 'pausada', diasRestantes: dias(s.prueba_hasta), hasta: s.prueba_hasta };
  }
  if (s.estado === 'activa') {
    if (!s.pagado_hasta) return { vigente: true, estado: 'activa', diasRestantes: null, hasta: null };
    const fin = new Date(s.pagado_hasta).getTime();
    const vigente = fin + 3 * 86400000 > ahora;
    return { vigente, estado: !vigente ? 'pausada' : fin > ahora ? 'activa' : 'gracia', diasRestantes: dias(s.pagado_hasta), hasta: s.pagado_hasta };
  }
  return { vigente: false, estado: 'pausada', diasRestantes: 0, hasta: null };
}

export function linkQuieroPlan({ negocioNombre, plan, ciclo, moneda, fundador }) {
  const p = planPorClave(plan);
  const pr = precioPlan(p, ciclo, moneda, fundador);
  const precio = ciclo === 'anual' ? `${pr.porMes}/mes pagando el año (${pr.alAnio})` : `${pr.porMes}/mes`;
  const texto = `¡Hola Kontrol! 👋 Quiero activar el plan ${p.nombre} (${ciclo}${fundador ? ', precio fundador' : ''}) — ${precio}.\nMi negocio: ${negocioNombre || ''}`;
  return `https://api.whatsapp.com/send?phone=${WHATSAPP_VENTAS}&text=${encodeURIComponent(texto)}`;
}

// ---- Pago con tarjeta (Tilopay) ----
// Se enciende con REACT_APP_PAGOS_TARJETA=1 en Vercel, después de poner las
// claves de Tilopay y correr "Configurar pasarela" en Admin Kontrol.
export const PAGO_TARJETA_ACTIVO = process.env.REACT_APP_PAGOS_TARJETA === '1';

async function llamarApi(ruta, cuerpo) {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) throw new Error('Tu sesión expiró. Vuelve a entrar.');
  const r = await fetch(ruta, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(cuerpo || {}),
  });
  const d = await r.json().catch(() => ({}));
  if (!r.ok || d.error) throw new Error(d.mensaje || 'No se pudo completar. Intenta de nuevo.');
  return d;
}

// Devuelve la URL de la página de pago de Tilopay para ese plan y ciclo.
export const iniciarPago = (plan, ciclo) => llamarApi('/api/pago?accion=iniciar', { plan, ciclo });

// Pagos del negocio (los ve la dueña; el admin ve todos).
export async function obtenerPagos(soloNegocio = true) {
  let q = supabase.from('pagos').select('id, negocio_id, correo, plan, ciclo, monto, moneda, proveedor, estado, motivo, creado_en').order('creado_en', { ascending: false }).limit(30);
  if (soloNegocio) q = q.eq('negocio_id', getNegocioId());
  const { data, error } = await q;
  if (error) throw error;
  return data || [];
}

// ---- Cancelar / reanudar (solo la dueña; lo valida la BD, sql/086) ----
// Cancelar = no renovar: el plan sigue hasta pagado_hasta y luego se pausa.
export async function cancelarMiPlan(motivo) {
  const { error } = await supabase.rpc('cancelar_mi_plan', { p_motivo: motivo || null });
  if (error) throw new Error(error.message.includes('SIN_PLAN_ACTIVO') ? 'No tienes un plan pagado activo.' : 'No se pudo cancelar. Intenta de nuevo.');
}
export async function reanudarMiPlan() {
  const { error } = await supabase.rpc('reanudar_mi_plan');
  if (error) throw new Error(error.message.includes('PLAN_VENCIDO') ? segunTienda('Tu plan ya venció: elige un plan para reactivarlo.', 'Tu plan ya venció.') : 'No se pudo reanudar. Intenta de nuevo.');
}

// ---- Solo admin de Kontrol (la BD lo verifica en cada función) ----
export const configurarPasarela = () => llamarApi('/api/pago?accion=configurar');

// Seguimiento de la prueba (sql/091): quién está en día 1-3, 7-9 o 12-14.
export async function adminSeguimientoPrueba() {
  const { data, error } = await supabase.rpc('admin_seguimiento_prueba');
  if (error) throw error;
  return data || [];
}
export async function adminMarcarSeguimiento(negocioId, etapa) {
  const { error } = await supabase.rpc('admin_marcar_seguimiento', { p_negocio: negocioId, p_etapa: etapa });
  if (error) throw error;
}
export async function esAdminKontrol() {
  const { data, error } = await supabase.rpc('es_admin_kontrol');
  if (error) return false;
  return data === true;
}

export async function adminListarSuscripciones() {
  const { data, error } = await supabase.rpc('admin_listar_suscripciones');
  if (error) throw error;
  return data || [];
}

export async function adminActualizarSuscripcion(negocioId, accion, plan, notas) {
  const { data, error } = await supabase.rpc('admin_actualizar_suscripcion', {
    p_negocio: negocioId, p_accion: accion, p_plan: plan || null, p_notas: notas || null,
  });
  if (error) throw error;
  return data;
}

// ---- Pago manual: transferencia o link de PayPal (sql/128) ----
// La dueña sube el comprobante y la admin lo aprueba en Admin Kontrol.
const BUCKET_COMPROBANTES = 'comprobantes-pago';

// { cuentas: [{banco, tipo, numero, titular}], paypal_usuario, instrucciones }
export async function datosCobro() {
  const { data, error } = await supabase.rpc('datos_cobro_kontrol');
  if (error) throw error;
  return data || { cuentas: [], paypal_usuario: null, instrucciones: null };
}
export const hayDatosCobro = (d) => !!(d && ((d.cuentas || []).length || d.paypal_usuario));

// Lanzamiento (sql/148): las clientas pagan desde el domingo 13-dic (00:00 de
// Honduras). Del 13 al 18-dic, quien no es fundador paga su primer mes a mitad
// de precio (solo mensual y solo si nunca ha pagado).
export const VENTAS_DESDE = Date.parse('2026-12-13T06:00:00Z');
export const PROMO_HASTA = Date.parse('2026-12-19T06:00:00Z');
export const ventasAbiertas = (ahora = Date.now()) => ahora >= VENTAS_DESDE;

// ¿Paga precio fundador en este plan? Igual que reportar_pago_manual (sql/148):
// el fundador es del plan que eligió; si lo perdió (cambió de plan o dejó de
// pagar) ya no lo recupera; las cortesías sin cupo reservado no lo toman.
export function fundadorEnPlan(sus, cupos, clave) {
  if (sus?.precio_fundador) return !sus.plan_fundador || sus.plan_fundador === clave;
  return !sus?.fundador_perdido && cupos > 0 && sus?.estado !== 'cortesia';
}

export function promoLanzamiento({ fundador, ciclo, pagos = [], ahora = Date.now() }) {
  return !fundador && ciclo === 'mensual' && ahora >= VENTAS_DESDE && ahora < PROMO_HASTA
    && !pagos.some((p) => p.estado === 'aprobado');
}

// Monto de UN cobro (anual = 12 meses al precio anual). Igual que precio_kontrol() en la BD.
// promo = 50% del primer mes del lanzamiento (lempiras hacia arriba; dólares a 2 decimales).
export function montoCobro(plan, ciclo, moneda, fundador = false, promo = false) {
  const p = planPorClave(plan);
  const m = monedaCobro(moneda);
  const porMes = (fundador ? p.fundador : p.precios)[m][ciclo];
  const total = Math.round(porMes * (ciclo === 'anual' ? 12 : 1) * 100) / 100;
  if (!promo) return total;
  return m === 'HNL' ? Math.ceil(total / 2) : Math.round((total / 2) * 100) / 100;
}
export const fmtCobro = (monto, moneda) => fmtMonto(monto, monedaCobro(moneda));
// PayPal cobra en dólares: los lempiras se pasan con TASA_LEMPIRA.
export const montoUsd = (monto, moneda) => (monedaCobro(moneda) === 'HNL' ? Math.ceil((monto / TASA_LEMPIRA) * 100) / 100 : monto);
export const linkPaypal = (usuario, usd) => `https://paypal.me/${encodeURIComponent(usuario)}/${usd.toFixed(2)}USD`;

export async function reportarPagoManual({ plan, ciclo, metodo, referencia, archivo }) {
  const negocioId = getNegocioId();
  const { comprimirFoto } = await import('./fotosService');
  const subir = archivo.type === 'application/pdf' ? archivo : await comprimirFoto(archivo);
  const ext = subir.type === 'application/pdf' ? 'pdf' : subir.type === 'image/png' ? 'png' : 'jpg';
  const ruta = `${negocioId}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
  const { error: errSubir } = await supabase.storage.from(BUCKET_COMPROBANTES).upload(ruta, subir, { contentType: subir.type || 'image/jpeg' });
  if (errSubir) throw new Error('No se pudo subir el comprobante. Revisa tu internet e intenta de nuevo.');
  const { data, error } = await supabase.rpc('reportar_pago_manual', {
    p_negocio: negocioId, p_plan: plan, p_ciclo: ciclo, p_metodo: metodo, p_ref_banco: referencia || null, p_comprobante: ruta,
  });
  if (error) {
    const m = error.message || '';
    throw new Error(m.includes('VENTAS_13_DIC') ? 'Los pagos abren el domingo 13 de diciembre. Tu prueba gratis sigue hasta el 14. 💜'
      : m.includes('DEMASIADOS') ? 'Ya enviaste varios comprobantes hoy. Escríbenos por WhatsApp.'
      : m.includes('NO_AUTORIZADO') ? 'Solo la dueña del negocio puede pagar el plan.' : 'No se pudo enviar. Intenta de nuevo.');
  }
  // Aviso al celular de la admin (si falla, igual queda en el panel).
  fetch('/api/cuenta?accion=aviso-pedido', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ pago: data }) }).catch(() => {});
  return data;
}

// Enlace temporal (10 min) para ver un comprobante (la dueña o la admin).
export async function urlComprobante(ruta) {
  const { data, error } = await supabase.storage.from(BUCKET_COMPROBANTES).createSignedUrl(ruta, 600);
  if (error) throw error;
  return data.signedUrl;
}

export async function adminPagosPorRevisar() {
  const { data, error } = await supabase.from('pagos')
    .select('id, negocio_id, correo, plan, ciclo, monto, moneda, proveedor, estado, comprobante, datos, creado_en')
    .eq('estado', 'revision').in('proveedor', ['transferencia', 'paypal'])
    .order('creado_en', { ascending: true });
  if (error) throw error;
  return data || [];
}
export async function adminRevisarPago(pagoId, aprobar, motivo) {
  const { data, error } = await supabase.rpc('admin_revisar_pago', { p_pago: pagoId, p_aprobar: aprobar, p_motivo: motivo || null });
  if (error) throw new Error(String(error.message).includes('YA_REVISADO') ? 'Este pago ya fue revisado.' : 'No se pudo guardar: ' + error.message);
  return data;
}
export async function adminGuardarDatosCobro({ cuentas, paypal_usuario, instrucciones }) {
  const { error } = await supabase.rpc('admin_guardar_datos_cobro', { p_cuentas: cuentas, p_paypal: paypal_usuario || null, p_instrucciones: instrucciones || null });
  if (error) throw new Error(String(error.message).includes('PAYPAL_INVALIDO') ? 'El usuario de PayPal no es válido (solo letras, números, punto o guion).' : 'Revisa los datos: cada cuenta necesita banco y número.');
}
